import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tableAnatomy.keys);

const baseTableStyle = definePartsStyle({
  table: {
    width: '100%',
  },
  thead: {
    tr: {
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'yGray.100',
      th: {
        py: 3,
        px: 4,
        color: 'yGray.900',
        textTransform: 'none',
        fontWeight: '600',
        lineHeight: '20px',
        fontSize: '14px',
      },
    },
  },
  tbody: {
    tr: {
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'yGray.100',
      td: {
        py: 3,
        px: 4,
        color: 'yGray.500',
        lineHeight: 5,
        fontWeight: 'medium',
        textTransform: 'none',
        fontSize: 'sm',
      },
    },
  },
});

const detailed = definePartsStyle({
  ...baseTableStyle,
  thead: {
    tr: {
      background: 'yGray.50',
    },
  },
});
const simple = definePartsStyle({
  ...baseTableStyle,
  thead: {
    tr: {
      background: 'transparent',
    },
  },
});
export const tableTheme = defineMultiStyleConfig({
  baseStyle: baseTableStyle,
  variants: {
    detailed,
    simple,
  },
});
